// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';
import { Path } from 'routes';
import { getApiPath, objectFetch } from 'util/commons';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import CollectRouteQRScanHeader from 'components/organisms/CollectRouteQRScanHeader';
import styles from './index.module.scss';
import { TenantRegistrationContent } from 'components/organisms/CollectTenantRegistrationContent';
import { useState } from 'react';
import { Tenant } from 'util/Types';

const CollectSubstituteRegistration = () => {
  const { t } = useTranslation();
  const { routeId, siteId } = useParams<{ routeId: string; siteId: string }>();
  const { state } = useLocation();
  const [selectedTenant, setSelectedTenant] = useState<Tenant>();
  const [hasCollectedSuccess, setHasCollectedSuccess] = useState(false);
  const history = useHistory();

  return (
    <CollectRouteTemplate
      showViewModeSwitch={false}
      h1={t('collects.title')}
      prevFunction={() => {
        if (selectedTenant) {
          setSelectedTenant(undefined);
        } else {
          history.push(
            `${getApiPath(Path.routeSiteSelection, {
              routeId: objectFetch(state, 'routeId') || routeId,
            })}${window.location.search}`,
            {
              refreshSites:
                hasCollectedSuccess || objectFetch(state, 'routeId'),
            }
          );
        }
      }}
      leftComponent={<CollectRouteQRScanHeader siteId={siteId} />}
      classNames={{
        actions: styles.actionBar,
      }}
    >
      <TenantRegistrationContent
        selectedTenant={selectedTenant}
        setSelectedTenant={setSelectedTenant}
        setHasCollectedSuccess={setHasCollectedSuccess}
      />
    </CollectRouteTemplate>
  );
};

export default CollectSubstituteRegistration;
